<script lang="ts">
	// Types
	import type { SvelteEvent } from '../../../../uc'

	// Props
	/**
	 * Set the radio group binding value.
	 * @type {any}
	 */
	export let group: any
	/** Set a unique name value for the input. */
	export let name: string
	/**
	 * Set the input's value.
	 * @type {any}
	 */
	export let value: any;
	/** Set the hover title. */
	export let title = ''

	// Props (A11y)
	/** Defines a semantic ARIA label. */
	export let label = ''

	// Local
	let elemInput: HTMLElement;

	// A11y Key Down Handler
	function onKeyDown(event: SvelteEvent<KeyboardEvent, HTMLDivElement>): void {
    console.log('click has happened')
		if (['Enter', 'Space'].includes(event.code)) {
			event.preventDefault()
			elemInput.click()
		}
	}

	// State
	$: checked = value === group

	// RestProps
	function prunedRestProps() {
		delete $$restProps.class
		return $$restProps
	}
</script>

<label class="radio-label" class:checked>
	<!-- A11y attributes are not allowed on <label> -->
	<div
		class="radio-item"
		data-testid="radio-item"
		role="radio"
		aria-checked={checked}
		aria-label={label}
		tabindex="0"
		{title}
		on:keydown={onKeyDown}
		on:keydown
		on:keyup
		on:keypress
	>
		<!-- NOTE: Don't use `hidden` as it prevents `required` from operating -->
		<div class="zero">
			<input bind:this={elemInput} type="radio" bind:group {name} {value} {...prunedRestProps()} tabindex="-1" on:click on:change />
		</div>
		<slot />
	</div>
</label>

<style lang="scss" global>
  .radio-label {
    cursor: pointer;
		font-size: inherit;
    
    &.checked {
      background-color: var(--uc-red);
      color: white;
    }

    &:hover, &:focus {
      background-color: var(--calhoon-maroon);
    }

    .zero {
      width: 0;
      height: 0;
      overflow: hidden;
    }

    .radio-item {
      padding: 0.5rem 1rem;
    }
  }
</style>